import React from 'react';
import PropTypes from 'prop-types';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { useStyles } from './styles';

export default function OverlayCard({
  disabled,
  items,
  label,
  onChange,
  value,
}) {
  const classes = useStyles();

  return (
    <FormControl fullWidth variant="outlined" className={classes.formControl}>
      <InputLabel id="select-outlined-label">{label}</InputLabel>
      <Select
        disabled={disabled}
        fullWidth
        labelId="select-outlined-label"
        value={value}
        onChange={onChange}
        label={label}
      >
        {items.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

OverlayCard.propTypes = {
  disabled: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

OverlayCard.defaultProps = {
  disabled: false,
  items: [],
  label: '',
  onChange() {},
  value: '',
};
